import api from "../../../../services/api";

// Id local (Clientes.id) do cliente de um ticket, a partir do código dele no
// ERP (`ticket.cliente.codigo_cliente`). Rotas como find/allServiceClient
// resolvem o ERP pelo `clienteId`. Com `erpId` (tela por ERP escolhido), casa
// também o ERP — o mesmo código pode existir em ERPs diferentes.
export default async function buscarClienteIdLocal(clienteErpId, erpId) {
  if (clienteErpId === undefined || clienteErpId === null) return undefined;
  const { data } = await api.get("/interno/getClients");
  return (Array.isArray(data) ? data : []).find(
    (cliente) =>
      cliente?.clienteErpId?.toString() === clienteErpId.toString() &&
      (!erpId || cliente?.erpId === erpId),
  )?.id;
}
